import PageHeader from './src/page-header2.mjs';
export { pageHeaderEmits, pageHeaderProps } from './src/page-header.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElPageHeader = withInstall(PageHeader);

export { ElPageHeader, ElPageHeader as default };
//# sourceMappingURL=index.mjs.map
